/*
 * File: button.ts
 * File Created: 2023-12-21 05:27:23
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:29:17
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop } from "vue-property-decorator";
import { BaseComponent } from "../base-classes";

@Component
export default class Button extends BaseComponent {
    @Prop({ type: String, required: false })
    icon?: string;

    /// rounded corner
    @Prop({ type: Boolean, required: false })
    pill?: boolean;

    /// equal width and height
    @Prop({ type: Boolean, required: false, default: false })
    equal?: boolean;

    /// public slots
    publicSlots = {
        click: "@click",
    };

    /// private helpers
    // for event binding
    visible: boolean = false;
    get update() {
        return {
            visible: (visible) => {
                this.visible = visible;
            },
        };
    }
    // wrap $listeners
    get listeners() {
        const click = Array.isArray(this.$listeners.click)
            ? this.$listeners.click
            : this.$listeners.click != null
              ? [this.$listeners.click]
              : null;

        return {
            ...this.$listeners,
            ...(click
                ? {
                      click: click.map((origin) => {
                          return (...args) => {
                              this.visible = true;
                              origin.apply(this, args);
                          };
                      }),
                  }
                : {
                      click: (...args) => {
                          this.visible = true;
                      },
                  }),
        };
    }
}
